import { render, staticRenderFns } from "./IconConfig.vue?vue&type=template&id=57da4b83"
import script from "./IconConfig.vue?vue&type=script&lang=js"
export * from "./IconConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports